export default{
    /*
    *  25 part table grid
    * */

    tg1:{
        width: '4%'
    },
    tg2:{
        width: '8%'
    },
    tg3:{
        width: '12%'
    },
    tg4:{
        width: '16%'
    },
    tg5:{
        width: '20%'    // 1/5
    },

    tg6:{
        width: '24%'
    },

    tg7:{
        width: '28%'
    },

    tg8:{
        width: '32%'
    },

    tg9:{
        width: '36%'
    },

    tg10:{
        width: '40%'
    },

    tg11:{
        width: '44%'
    },

    tg12:{
        width: '48%'
    },

    tg13:{
        width: '52%'
    },

    tg14:{
        width: '56%'
    },

    tg15:{
        width: '60%'
    },

    tg16:{
        width: '64%'
    },

    tg17:{
        width: '68%'
    },

    tg18:{
        width: '72%'
    },

    tg19:{
        width: '76%'
    },

    tg20:{
        width: '80%'
    },
    tg21:{
        width: '84%'
    },
    tg22:{
        width: '88%'
    },
    tg23:{
        width: '92%'
    },
    tg24:{
        width: '96%'
    },
    tg25:{
        width: '100%'
    },
}


// WEBPACK FOOTER //
// ./src/utilities/TabGrid.js